import {
  Briefcase,
  Building,
  Eye,
  Globe,
  Megaphone,
  Monitor,
  Search,
  User,
  Zap,
} from "lucide-react";
import type { CategoryStyle, MetricCategory } from "./types";

// Define chart colors using CSS variables for theme consistency
export const CHART_COLORS = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))",
  "hsl(var(--chart-6))",
];

// Define category styles
export const CATEGORY_STYLES: Record<MetricCategory, CategoryStyle> = {
  Account: {
    color: "bg-metric-account/10 text-metric-account shadow-sm",
    pillColor:
      "bg-metric-account/10 text-metric-account ring-1 ring-inset ring-metric-account/20 hover:bg-metric-account/20 transition-colors cursor-pointer",
    icon: <Building className="h-3 w-3" />,
  },
  Opportunity: {
    color: "bg-metric-opportunity/10 text-metric-opportunity shadow-sm",
    pillColor:
      "bg-metric-opportunity/10 text-metric-opportunity ring-1 ring-inset ring-metric-opportunity/20 hover:bg-metric-opportunity/20 transition-colors cursor-pointer",
    icon: <Briefcase className="h-3 w-3" />,
  },
  Person: {
    color: "bg-metric-person/10 text-metric-person shadow-sm",
    pillColor:
      "bg-metric-person/10 text-metric-person ring-1 ring-inset ring-metric-person/20 hover:bg-metric-person/20 transition-colors cursor-pointer",
    icon: <User className="h-3 w-3" />,
  },
  Campaign: {
    color: "bg-metric-campaign/10 text-metric-campaign shadow-sm",
    pillColor:
      "bg-metric-campaign/10 text-metric-campaign ring-1 ring-inset ring-metric-campaign/20 hover:bg-metric-campaign/20 transition-colors cursor-pointer",
    icon: <Megaphone className="h-3 w-3" />,
  },
  Channel: {
    color: "bg-metric-channel/10 text-metric-channel shadow-sm",
    pillColor:
      "bg-metric-channel/10 text-metric-channel ring-1 ring-inset ring-metric-channel/20 hover:bg-metric-channel/20 transition-colors cursor-pointer",
    icon: <Globe className="h-3 w-3" />,
  },
  Touchpoint: {
    color:
      "bg-metric-touchpoint/20 text-metric-touchpoint-foreground shadow-sm",
    pillColor:
      "bg-metric-touchpoint/20 text-metric-touchpoint-foreground ring-1 ring-inset ring-metric-touchpoint/30 hover:bg-metric-touchpoint/30 transition-colors cursor-pointer",
    icon: <Zap className="h-3 w-3" />,
  },
  Engagement: {
    color: "bg-metric-engagement/10 text-metric-engagement shadow-sm",
    pillColor:
      "bg-metric-engagement/10 text-metric-engagement ring-1 ring-inset ring-metric-engagement/20 hover:bg-metric-engagement/20 transition-colors cursor-pointer",
    icon: <Eye className="h-3 w-3" />,
  },
  Session: {
    color: "bg-metric-session/10 text-metric-session shadow-sm",
    pillColor:
      "bg-metric-session/10 text-metric-session ring-1 ring-inset ring-metric-session/20 hover:bg-metric-session/20 transition-colors cursor-pointer",
    icon: <Monitor className="h-3 w-3" />,
  },
  Other: {
    color: "bg-metric-other/10 text-metric-other shadow-sm",
    pillColor:
      "bg-metric-other/10 text-metric-other ring-1 ring-inset ring-metric-other/20 hover:bg-metric-other/20 transition-colors cursor-pointer",
    icon: <Search className="h-3 w-3" />,
  },
};
